module.exports = __webpack_public_path__ + "img/pic_291250.ae836ff0.jpg";